import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuth } from '@redtrack/auth-core';
import SplashScreen from 'src/components/SplashScreen';
import ROUTES from '../../constants/system/routes';

function AuthGuard({ children }) {
  const { isAuthenticated, isLoaded } = useAuth();

  if (!isLoaded) {
    return <SplashScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.AUTH.LOGIN.URL()} />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthGuard;
